import { render, staticRenderFns } from "./StockFilter.vue?vue&type=template&id=912b8882&scoped=true&"
import script from "./StockFilter.vue?vue&type=script&lang=js&"
export * from "./StockFilter.vue?vue&type=script&lang=js&"
import style0 from "./StockFilter.vue?vue&type=style&index=0&id=912b8882&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912b8882",
  null
  
)

export default component.exports